export default "__VITE_ASSET__758e41a3__"